// Who paid: the user's own model key against the platform's, as a two-part bar with its legend.
import { cn } from "../ui/cn";
import { useT } from "../i18n";
import { money, paidSplit, type CostReport } from "./model";

export function PaidSplitBar({ report, className }: { report: Pick<CostReport, "org_cost_usd" | "platform_cost_usd">; className?: string }) {
  const t = useT().costs;
  const split = paidSplit(report);
  const parts = [
    { key: "org", label: t.usersKey, value: split.org, pct: 100 - split.platformPct, color: "bg-[rgb(var(--chart-1))]" },
    { key: "platform", label: t.platformKey, value: split.platform, pct: split.platformPct, color: "bg-[rgb(var(--chart-2))]" },
  ];
  const spent = split.org + split.platform > 0;
  return (
    <div className={className}>
      <div className="flex h-2.5 gap-0.5 overflow-hidden rounded-full bg-gray-100">
        {spent ? parts.filter((p) => p.value > 0).map((p) => <div key={p.key} className={cn("h-full", p.color)} style={{ width: `${p.pct}%`, minWidth: 6 }} />) : null}
      </div>
      <ul className="mb-0 mt-2.5 list-none space-y-1 p-0 text-[13px]">
        {parts.map((p) => (
          <li key={p.key} className="flex items-center gap-2 text-gray-600">
            <span className={cn("h-2.5 w-2.5 rounded-sm", p.color)} />
            {p.label}
            <span className="tabular ms-auto font-medium text-gray-900">{money(p.value)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
